import { Box, Divider, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { SectionTemplate } from "./section-template";
import Image from "next/image";
import { DynamicSectionProps, flexStyles, getAlign } from "./section";
import { insertLineBreaks } from "utils/resolve-template";
import { RichText } from "@graphcms/rich-text-react-renderer";
import { customRichText } from "../mdx-components";
import { Button, ButtonActions } from "@ui/components";
import { RichTextContent } from "@graphcms/rich-text-types";
import { Gcms_ContentPosition } from "lib/cms-typings";

export const FeaturedRiskSection = ({
  contentPosition,
  textAlignment,
  subtitle,
  content,
  title,
  titleColor,
  image,
  buttons,
  bg,
  from,
}: DynamicSectionProps) => {
  return (
    <SectionTemplate bg={bg}>
      <Stack
        spacing={{ base: "4", lg: "20" }}
        {...flexStyles[contentPosition as Gcms_ContentPosition]}
        alignItems="center"
      >
        <Box
          maxW={{
            base: "2xl",
            lg: from === "about" ? "75%" : "full",
          }}
          textAlign={{
            base: "center",
            lg: getAlign(textAlignment),
          }}
        >
          {from !== "about" && (
            <Flex
              justify={"center"}
              mb={{
                base: "-13px",
                lg: 6,
              }}
              align={"center"}
              gap={{
                base: 5,
                lg: 10,
              }}
            >
              <Divider
                orientation="horizontal"
                w={{
                  base: "full",
                  sm: "60px",
                  md: "80px",
                  lg: "100px",
                }}
                opacity={1}
                borderColor={"black"}
                borderWidth={1.5}
              />

              <Text
                fontSize={{
                  base: "md",
                  md: "lg",
                  lg: "xl",
                }}
                fontWeight={"bold"}
                minW={"max"}
              >
                {subtitle}
              </Text>

              <Divider
                orientation="horizontal"
                w={{
                  base: "full",
                  sm: "60px",
                  md: "80px",
                  lg: "100px",
                }}
                opacity={1}
                borderColor={"black"}
                borderWidth={1.5}
              />
            </Flex>
          )}

          <Heading
            as="h2"
            fontSize={{
              base: 26,
              md: 34,
              lg: 38,
              xl: 45,
            }}
            letterSpacing="tight"
            fontWeight="bold"
            lineHeight={1.2}
            textColor={titleColor ?? "inherit"}
          >
            {insertLineBreaks(title)}
          </Heading>
          <Box as="div">
            <RichText
              content={content as RichTextContent}
              renderers={customRichText("black", 1.5, 8)}
            />
          </Box>

          {image && (
            <Box
              mt={{
                lg: 5,
              }}
              mb={{
                base: 5,
                lg: 3,
              }}
              maxW={{
                base: "120px",
              }}
              mx="auto"
            >
              <Image
                style={{ objectFit: "cover" }}
                src={image?.url as string}
                blurDataURL={
                  typeof image?.blurDataURL === "string"
                    ? image?.blurDataURL
                    : undefined
                }
                placeholder={
                  typeof image?.blurDataURL === "string" ? "blur" : undefined
                }
                width={150}
                height={150}
                alt={image?.alt as string}
              />
            </Box>
          )}

          <Flex justify={"center"}>
            {buttons?.map((button: any, idx) => (
              <Button
                key={idx}
                __type={button.buttonAction as ButtonActions}
                href={button.href as string}
                color={"black"}
                bgColor={"white"}
                variant={button.variant}
                borderWidth={1}
                borderColor="black"
                label={button.label}
                mt={{
                  lg: "4",
                }}
                py={{
                  base: "6",
                  lg: "8",
                }}
                px="5"
              />
            ))}
          </Flex>
        </Box>
      </Stack>
    </SectionTemplate>
  );
};
